import { render, staticRenderFns } from "./SearchPBundles.vue?vue&type=template&id=3b4e59a2"
import script from "./SearchPBundles.vue?vue&type=script&lang=js"
export * from "./SearchPBundles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports